// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
//import '@/styles/rew19_aro.css'
import '@babel/polyfill'
import 'es6-promise/auto'

import Vue from 'vue'
import App from './App'
import router from './router'

import axios from 'axios'
import '@/styles/dialog.css'
import SlimDialog from '@/components/Dialog'

import formatNum from 'format-number'
import store from '@/store'

import * as common from '@/utils/common'
import { version } from 'core-js'

Vue.use(SlimDialog)

{ //Set base prototype
  Vue.prototype.$http = axios
  Vue.prototype.$fmt = {
    WON : formatNum({prefix: '', integerSeparator:',', round: 0})
    , PDCnt : formatNum({prefix: '', integerSeparator:','})
    , PV : formatNum({prefix: '', decimal :'.', round: 2})
    , SV : formatNum({prefix: '', decimal :'.', round: 2})
  }

  //Nuskin api jsonp 대응
  Vue.prototype.$parseNuskinApiRes = function(res){
    if(!res || typeof res !== 'string'){
      return null;
    }

    let retData = res;
    retData = retData.replace(/^\(+/, "");
    retData = retData.replace(/\)+$/, "");

    return retData;
  }

  //Get Max z-index of Dialog
  Vue.prototype.$getDimmMaxIndex = function(baseZIndex){
    let maxIdx = baseZIndex ? baseZIndex : 2000;

    try{
      $("div.dimmed_black").each(function(idx, elem){
        let obj = $(elem);
        let tZIdx = obj.css("z-index");
        let tDisplay = obj.css("display");

        if(tDisplay != "none"){
          tZIdx = tZIdx ? parseInt(tZIdx, 10) : 1;
          maxIdx = Math.max(maxIdx, tZIdx);
        }
      });
    }catch(e){
      //Ignore
      maxIdx = baseZIndex;
    }

    return maxIdx;
  }

  //Modal treat function
  Vue.prototype.$modalAfterTreat = function(show){
    const scrollLockClass = this.$openModalBodyClassName;
    let bodyClassList = document.body.classList;

    if(show && !bodyClassList.contains(scrollLockClass)){
      bodyClassList.add(scrollLockClass);
    }

    if(!show && bodyClassList.contains(scrollLockClass)){
      bodyClassList.remove(scrollLockClass);
    }
  };
}

{ //For IE
  if (!String.prototype.includes) {
    String.prototype.includes = function(search, start) {
      'use strict';
      if (typeof start !== 'number') {
        start = 0;
      }

      if (start + search.length > this.length) {
        return false;
      } else {
        return this.indexOf(search, start) !== -1;
      }
    };
  }

  if (!Array.prototype.includes) {
    Object.defineProperty(Array.prototype, "includes", {
      enumerable: false,
      value: function(obj) {
          var newArr = this.filter(function(el) {
            return el == obj;
          });
          return newArr.length > 0;
        }
    });
  }
}

{ //Set global value
  let aroConfig = common.getGlobalAroConfig();
  Vue.prototype.$aroConfig = aroConfig;

  //Values
  Vue.prototype.$aroChannel = aroConfig.channel;
  Vue.prototype.$aroBasePath = aroConfig.aroBaseUrl;
  Vue.prototype.$aroApiBasePath = aroConfig.aroApiBaseUrl;
  Vue.prototype.$zipApiBasePath = aroConfig.zipApiBaseUrl;
  Vue.prototype.$aroShopBasketFullPath = aroConfig.shopBasketPageUrl;
  Vue.prototype.$shopGiftBasketPageUrl = aroConfig.shopGiftBasketPageUrl;
  Vue.prototype.$openModalBodyClassName = aroConfig.openModalBodyClassName;
  Vue.prototype.$usingGraceFunction = aroConfig.usingGraceFunction;

  //Functions
  Vue.prototype.$aroUiInitialize = aroConfig.fn_uiInitialize;
  Vue.prototype.$showLoading = aroConfig.fn_showLoading;
  Vue.prototype.$hideLoading = aroConfig.fn_hideLoading;
  Vue.prototype.$openLoginConfirm = aroConfig.fn_openLoginConfirm;
  Vue.prototype.$showProductBanner = aroConfig.fn_showProductBanner;
  Vue.prototype.$aroSnsInit = aroConfig.fn_aroSnsInit;
  Vue.prototype.$aroSnsShareAction = aroConfig.fn_aroSnsShareAction;
  Vue.prototype.$aroUrlShareAction = aroConfig.fn_aroUrlShareAction;
  Vue.prototype.$changeBasketCount = aroConfig.fn_changeBasketCount;
  Vue.prototype.$imageError = aroConfig.fn_imageError;

  // GA Function
  Vue.prototype.$sendAroGA = aroConfig.fn_sendAroGA;

  Vue.prototype.$december1st = aroConfig.december1st;
  Vue.prototype.$january1st = aroConfig.january1st;
}

Vue.config.productionTip = false

const mEnvVal = process.env.NODE_ENV;
console.log("mEnvVal = " + mEnvVal);
if ("development" === mEnvVal) {
  const $httpVal = Vue.prototype.$http;
  $httpVal.defaults.withCredentials = true;
}


/* eslint-disable no-new */
window.ARO_VUE_APP = new Vue({
  el: '#aro_app',
  router,
  store,
  components: { App },
  template: "<App ref='AroApp'/>",
  data: {}
})



// WEBPACK FOOTER //
// ./src/main.js